import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation} from "react-router-dom";
import '../../assets/css/home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';

import Master_Front from "../../pages/Master_Front";
import Aside from "../../components/Aside";
import Card_view from "../../components/Cart_box/Card_view";
import Post_product_Gride from "../../components/Grid_box/Post_product_Gride";
import Slider_show_home from "../../components/Sliders_box/Slider_show_home";

import Sticky from 'react-stickynode';


import {Skeleton} from "@mui/material";


const Home = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */




    const is_device_mobile = window.matchMedia("(max-width: 700px)");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_category_box, set_data_category_box] = useState([]);

    const [Cart_shop_itemendd, setDatacartendd] = useState("");


    const [activeSection, setActiveSection] = useState('sec-1');

    const [scrollY, setScrollY] = useState(0);

    function logit() {
        setScrollY(window.pageYOffset);
    }



    useEffect(() => {
       /// scrollTo_uphk();
        Load_api_page();
    }, [location_get_urlbk]);



    useEffect(() => {
        window.addEventListener('resize', setWindowDimensions);
        return () => {
            window.removeEventListener('resize', setWindowDimensions)
        }
    }, []);





    const setWindowDimensions = () => {
        setWindowWidth(window.innerWidth)
    }


    const handleLinkClick = (section) => {
        setActiveSection(section);
        scrollToSection(section);
    };

    const scrollToSection = (section) => {
        const element = document.getElementById(section);

    };


    const Load_api_page= () => {

       /// Setloadinghkfullshow("true");
        var config = null;

        if(check_login_appbk()==true){
             config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }

        var id_get_agent=Agent_by_user_get_appbk("id_agent");

        if(!empty_bk(id_get_agent)){

            const data_form_add = {cart_items:Cart_shop_itemendd,id_agent:String(id_get_agent)};

            axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data`,data_form_add,config)
                .then((res) => {

                    /// Setloadinghkfullshow("false");

                    if(String(res.data).length > 0) {

                        if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                        if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                        if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }



                        if(String(res.data.data_slider_list).length > 0) {  set_data_slider_list(res.data.data_slider_list); }
                        if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }



                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                /// Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور،اینترنت خود را بررسی کنید', {position: "top-center", autoClose:7000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });

        }








    }


    return (
      <Fragment>

<Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >


    <ToastContainer />

  <Slider_show_home data_slider_list={data_slider_list}    />




    <section className='w-100 flexRowBetStart home-section-container home-products-show'>


        <div className={"aside-container-main side-bar-right-homebk"}>
            <Sticky top="#sidebarrightbk" bottomBoundary="#content">
            <Aside costume_class={"side_bar_pc_home"} data_category_box={data_category_box} />
            </Sticky>
        </div>




        <section id={"content"} className='flexColStartStart home-items-container home-content-main-bk'>


            {
                data_category_box.length==0 ?  (
                    <React.Fragment>

                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />
                        <Skeleton variant="rectangular"    style={{marginTop: "5px",width:"100%",height:"200px"}} />

                    </React.Fragment>


                ) : (




                    data_category_box.map((item_post,index) => {

                        return (





                            <Fragment>


            {



                (() => {

                    if(parseInt(item_post.count_products) > 0 ){
var item_number=0;

item_number = parseInt(index) +1 ;

                        return (

                            <div className='w-100 cate-container' id={"sec-" + String(item_post.id_post)}>
                                <div className='title-sec-cat-home'>
                                    <img src={item_post.image_src}  alt={item_post.title_post} />
                                    <span>{item_post.title_post}</span>
                                </div>
                                <Post_product_Gride custom_class_box_link={"hover12"}  link_post_main={"/post"}  data_posts_list={item_post.list_products}/>
                            </div>

                        )

                    }


            })()



            }






                            </Fragment>



                        );

                    })



                ) }



        </section>



        <div id={"card_box_bk"} className={"card-container card-box-bk"}>
            <Sticky  top="#sidebarleftbk" bottomBoundary="#content"  >
            <Card_view />
            </Sticky>
        </div>





    </section>



</Master_Front>

      </Fragment>
    );
  }
  
  export default Home;